import { DateTime } from "luxon"
import { CreateOrEditShopFormValues, LanguageCode, ShopDetailsType } from "../shopsTypes"

export const prepareInitialValues = (shopDetailsResult?: ShopDetailsType): CreateOrEditShopFormValues => {
    return {
        name: shopDetailsResult?.name ?? "",
        type: shopDetailsResult?.type,
        isActive: shopDetailsResult?.isActive ?? true,
        demoMode: shopDetailsResult?.demoMode ?? false,
        caseNumber: shopDetailsResult?.caseNumber ?? "",
        internalNote: shopDetailsResult?.internalNote ?? "",
        paymentDetails: {
            paymentMethods: shopDetailsResult?.paymentDetails?.paymentMethods ?? [],
        },
        shopDetails: {
            isPublic:
                shopDetailsResult?.shopDetails?.isPublic !== undefined ? shopDetailsResult.shopDetails.isPublic : false,
            settings: shopDetailsResult?.shopDetails.settings ?? {
                showQRReceipt: true,
                acceptMultipleCheckIns: true,
            },
            publicShopDetails: shopDetailsResult?.shopDetails.publicShopDetails ?? undefined,
        },
        deadline: shopDetailsResult?.deadline
            ? {
                  purchases: {
                      ...shopDetailsResult.deadline.purchases,
                      timeOfDay: DateTime.fromISO(shopDetailsResult.deadline.purchases.timeOfDay),
                  },
                  cancellation: {
                      ...shopDetailsResult.deadline.cancellation,
                      timeOfDay: DateTime.fromISO(shopDetailsResult.deadline.cancellation.timeOfDay),
                  },
              }
            : null,
        posDetails: {
            defaultLanguage: shopDetailsResult?.posDetails?.defaultLanguage ?? LanguageCode.DA,
            returnToHomeScreenDelay: shopDetailsResult?.posDetails?.returnToHomeScreenDelay ?? 3000,
            returnToHomeAfterPurchase: shopDetailsResult?.posDetails?.returnToHomeAfterPurchase ?? 3000,
        },
    }
}
